import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import React from 'react';
import Home from '../pages/Home';
import Login from "../pages/Login";
import Searcher from "../components/Searcher";
import MyAudiobooks from "../components/MyAudioBooks";
import AudioPlayer from "../components/AudioPlayer";
import Perfil from "../components/Perfil";
import UserDashboard from "../components/UserDashboard";
import UserDetail from "../components/UserDetail";
import UserCreate from "../components/Create";
import SearchResultsList from "../components/SearchResultsList";
import GenreBooks from "../components/GenreBooks";
import PrivateRoute from "./PrivateRoute";

function GeneralRoutes() {
  const location = useLocation();
  return (
    <Routes location={location}>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />

      <Route path="/search" element={<PrivateRoute><Searcher /></PrivateRoute>} />
      <Route path="/mis-audiolibros/:usuarioId" element={<PrivateRoute><MyAudiobooks /></PrivateRoute>} />
      <Route path="/reproducir/:usuarioId/:audiolibroId" element={<PrivateRoute><AudioPlayer /></PrivateRoute>} />
      <Route path="/perfil" element={<PrivateRoute><Perfil /></PrivateRoute>} />
      <Route path="/users/" element={<PrivateRoute requiredRole="Admin"><UserDashboard /></PrivateRoute>} />
      <Route path="/users/info/:id" element={<PrivateRoute requiredRole="Admin"><UserDetail /></PrivateRoute>} />
      <Route path="/user/create" element={<PrivateRoute requiredRole="Admin"><UserCreate /></PrivateRoute>} />
      <Route path="/results-list/:usuarioId" element={<PrivateRoute><SearchResultsList /></PrivateRoute>} />
      <Route path="/books-by-genre/:genre/:usuarioId" element={<PrivateRoute><GenreBooks /></PrivateRoute>} />
    </Routes>
  );
}

export default GeneralRoutes;